import(/* webpackMode: "eager" */ "/srv/node_modules/next/dist/client/link.js");
